import { keyBy } from 'lodash'

const dotNumbers = {
  getDotNumberMap: (state) => {
    const { dotNumbers: { dotNumbers } } = state
    return keyBy(dotNumbers || {}, '_id')
  }
}

export { dotNumbers }